import { defineMessages } from 'react-intl';

const messages = defineMessages({
  ShopAvailableProducts: {
    defaultMessage: 'Shop {availableProductCount} available products',
    description: 'Navigation link to go to the shop page.'
  }
});

export default messages;
